import { AxiosHeaders } from 'axios';

import { HttpHeader } from '../../../common/enums';
import { fetchRefreshedToken } from '../api';
import { StorageKey } from '../enums';
import { WebStoreApiRefreshTokensRequestBody } from '../models';
import { getAuthBearerValue } from './get-auth-bearer-value';

import { getWebStoreApiConfig } from '../config';

/**
 * Refreshes either guest or auth JWT.
 * @param token Previous JWT
 * @param accessToken Access JWT
 * @returns Promise with new JWT.
 */
export const refreshToken = async (token: string, accessToken?: string): Promise<string> => {
  const { storage, siteContext, marketLocale } = getWebStoreApiConfig();
  const body: WebStoreApiRefreshTokensRequestBody = {
    brand: siteContext,
    marketLocale,
    previousToken: token,
  };
  const headers: AxiosHeaders = new AxiosHeaders();
  if (accessToken) {
    headers.set(HttpHeader.Authorization, getAuthBearerValue(accessToken));
  }

  const response = await fetchRefreshedToken(body, headers);

  const newToken: string | null = response.token;
  if (!newToken) {
    return Promise.reject('Authorization header was not found in refresh token response');
  }

  const storageKey: string = accessToken
    ? StorageKey.WebStoreAuthToken
    : StorageKey.WebStoreGuestToken;
  storage.setItem(storageKey, newToken);

  return newToken;
};
